<template>
  <div class="site-team-table">
    <div class="row table-title" v-if="displayMobileView === false">
      <div class="col-md-6 pl-0 font-bolder">Site Team Tasks</div>
      <div class="col-md-6 align-right pr-0" v-if="milestoneView">
        <span v-if="!showHideCompliance"
          ><span class="font-bolder pr-10">{{ siteTeamTaskCompletionPR }}%</span>Complete</span
        >
      </div>
    </div>
    <div class="row table-title" v-if="displayMobileView === true">
      <div class="col pl-0 font-bolder">Site Team Tasks</div>
      <div class="col text-right pr-0" v-if="milestoneView">
        <span v-if="!showHideCompliance"
          ><span class="font-bolder pr-10 ">{{ siteTeamTaskCompletionPR }}%</span>Complete</span
        >
      </div>
    </div>
    <div v-if="displayMobileView === false" class="divTable unstyledTable">
      <div class="divTableHeading">
        <div class="divTableRow">
          <div class="divTableHead" :class="field.class" v-for="(field, index) in siteTeamActionFields" :key="index">
            <b class="mr-5">{{ field.label }}</b>
            <span class="sortDown mr-2" @click="sortField(field, 'asc')" :class="{ 'disable-icon': !field.ascOrder }"><i class="fa fa-long-arrow-down" aria-hidden="true"></i></span>
            <span class="sortUp" @click="sortField(field, 'desc')" :class="{ 'disable-icon': !field.dscOrder }"><i class="fa fa-long-arrow-up" aria-hidden="true"></i></span>
          </div>
        </div>
      </div>
      <div class="divTableBody" :class="{ 'loading-opacity': apiIsInProgress }" v-if="edcForms && edcForms.length > 0">
        <div class="divTableRow" v-for="(record, index) in tasksArrOne" :key="index">
          <div class="divTableCell text-info">
            <span v-if="(isStudyTeam || canSupportAccess) && record.label != null && (record.label.toLowerCase() == 'missed' || record.label.toLowerCase() == 'pending' || record.label.toLowerCase() == 'start' || isFormOrPacketRemoved(record))">
              <span v-if="record.label != null" class="status disabled" :class="record.label.toLowerCase()">
                <span>{{ label[record.label] }}</span>
                <i v-if="record.label.toLowerCase() == 'start'" class="fa fa-play ml-5" aria-hidden="true"></i>
              </span>
            </span>
            <span v-else>
              <span @click="submitNewForm(record, $event)" v-if="record.label != null" class="status" :class="record.label.toLowerCase()">
                <span>{{ label[record.label] }}</span>
                <i v-if="record.label.toLowerCase() == 'start'" class="ml-5 fa fa-play" aria-hidden="true"></i>
              </span>
            </span>
            <div
              :id="record.taskId"
              :class="{
                'form-name-reschedule': record.label.toLowerCase() == 'reschedule',
                'form-name': record.label.toLowerCase() != 'reschedule',
                disabled: ((isStudyTeam || canSupportAccess) && (record.label.toLowerCase() == 'missed' || record.label.toLowerCase() == 'start')) || ((canNotViewDetailsOfPackets || canSupportAccess) && record.label.toLowerCase() == 'pending'),
                'removed-form-name': isFormOrPacketRemoved(record)
              }"
              @click="changeState(record)"
            >
              <span :id="`site-task-${record.taskId}-${index}`" :title="record.taskName">{{ truncate(record) }}</span>
              <span class="ml-10" v-if="checkViewPermissions(record).canView == false"> <img width="20px" src="static/img/permission-eye.svg" alt v-b-popover.hover="'You do not have the permission to view this activity'" :popover-style="{ background: '#ffffff' }" />̥ </span>
              <img alt="" class="ml-10 visitPreSelectedIcon" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.responseId === null" @click="callVisitDetails(record)" src="static/img/telehealth/telehealth_comingUp.png" />
              <img alt="Home Visit" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.responseId !== null && record.visitType === 'Homevisit'" class="visitTypeIconDisplay" @click="callVisitDetails(record)" src="static/img/telehealth/homeVisitLogo.svg" />
              <img alt="Phone Call" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.responseId !== null && record.visitType === 'Phonecall'" class="visitTypeIconDisplay" @click="callVisitDetails(record)" src="static/img/telehealth/phonecallLogo.svg" />
              <img alt="In Person" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.responseId !== null && record.visitType === 'In-person'" class="visitTypeIconDisplay" @click="callVisitDetails(record)" src="static/img/telehealth/office-visit-icon.svg" />
              <img alt="Telehealth" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.responseId !== null && record.visitType === 'Telehealth'" class="visitTypeVideoCallIconDisplay" @click="callVisitDetails(record)" src="static/img/telehealth/video-call-icon.jpg" />
              <!-- when archive list length is freator then 1 then show popover -->
              <b-tooltip :target="`site-task-${record.taskId}-${index}`" placement="top" v-if="checkViewPermissions(record).canView" triggers="hover blur">{{ record.taskName }}</b-tooltip>
              <span v-if="record.archiveList && record.archiveList.length > 1 && canAccessArchiveList" @click="clickStopVisitModal()">
                <span :id="record.taskId" tabindex="0" class="camera" v-if="record.taskType == 'TELEHEALTH_UNSCHEDULED' && record.archiveList != null">
                  <span
                    class="double-camera"
                    :class="{
                      'double-green': record.taskId == mainActiveArchiveId
                    }"
                    >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                  >
                </span>
                <span id="SITE_SCHEDULED_TELEHEALTH_1" tabindex="0" class="camera" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.archiveList != null">
                  <span
                    class="double-camera"
                    :class="{
                      'double-green': record.taskId == mainActiveArchiveId
                    }"
                    >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                  >
                </span>
                <b-popover v-if="record.taskId && record.taskType == 'SITE_SCHEDULED_TELEHEALTH'" :ref="'element' + record.taskId" target="SITE_SCHEDULED_TELEHEALTH_1" triggers="click blur">
                  <template v-slot:content>
                    <div @click="openRecording($event, record, archive, 'element' + record.taskId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                      <div class="open-recording mr-10">
                        {{ new Date(archive.startTime) | formatUTCDate }}
                      </div>
                      <span
                        class="blue-camera"
                        :class="{
                          'single-green': archive.archiveId == activeArchiveId
                        }"
                      ></span>
                    </div>
                  </template>
                </b-popover>
                <b-popover v-if="record.taskId && record.taskType != 'SITE_SCHEDULED_TELEHEALTH'" :ref="'element' + record.taskId" :target="record.taskId" triggers="click blur">
                  <template v-slot:content>
                    <div @click="openRecording($event, record, archive, 'element' + record.taskId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                      <div class="open-recording mr-10">
                        {{ new Date(archive.startTime) | formatUTCDate }}
                      </div>
                      <span
                        class="blue-camera"
                        :class="{
                          'single-green': archive.archiveId == activeArchiveId
                        }"
                      ></span>
                    </div>
                  </template>
                </b-popover>
              </span>
              <!-- else show simple form of camera -->
              <span v-else>
                <span v-if="record.archiveList && record.archiveList.length == 1 && (record.taskType == 'TELEHEALTH_UNSCHEDULED' || record.taskType == 'SITE_SCHEDULED_TELEHEALTH') && canAccessArchiveList" @click="openRecording($event, record, record.archiveList[0])" class="camera">
                  <span
                    class="single-camera"
                    :class="{
                      'single-green': record.taskId == mainActiveArchiveId
                    }"
                  ></span>
                </span>
              </span>
              <span v-if="record.missedDueToMSSkip" class="skipped-task" aria-hidden="true" v-b-popover.hover="'Activity has been skipped due to change in study day'" :popover-style="{ background: '#ffffff' }">
                <img alt="Activity Skipped" src="static/img/Icon_ Activity_Skipped.png" />
              </span>
            </div>
            <span class="ml-5 ondemand-activity-icon" v-if="record.taskInstanceId && record.taskInstanceId.includes('on_demand')" data-toggle="modal" @click="onDemandModalshow(record)">
              <img alt="Send Activity" src="static/img/participant-profile/send_activity_on.svg" />
            </span>
          </div>
          <div class="divTableCell">
            <span v-if="record.state.toLowerCase() != 'complete' && record.dueDate && triggerForSiteTeamTask && record.scheduleDate != 0 && record.scheduleDate != null" class="due-date-indicator">{{ record.scheduleDate }}</span>
            <span v-if="record.state.toLowerCase() != 'complete' && record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.scheduleDate != 0 && record.scheduleDate != null" class="due-date-indicator">{{ record.scheduleDate }}</span>
          </div>
          <div class="divTableCell color-text w-220">
            <div v-if="record.label != null && (record.label.toLowerCase() == 'pending' || record.label.toLowerCase() == 'complete' || record.label.toLowerCase() == 'cancelled' || record.label.toLowerCase() === 'reschedule') && record.responseTimeUTC != null">
              <span>{{ new Date(record.responseTimeUTC) | formatUTCDate }}</span>
              <span v-bind:id="`record.responseTimeUTC${index}`" tabindex="0" class="clock ml-5"></span>
              <b-popover v-bind:target="`record.responseTimeUTC${index}`" triggers="click blur">
                <template v-slot:content>
                  <div class="popover-content">
                    <span class="clinic"></span>
                    <div class="ml-20 w-170 text-uppercase" v-html="toUserLocalTime(record.responseTimeUTC)"></div>
                  </div>
                </template>
              </b-popover>
            </div>
          </div>
          <div class="divTableCell color-text">{{ record.submittedBy }}</div>
          <div class="divTableCell">
            <span v-if="record.openQueryCount" class="open-query">{{ record.openQueryCount }}</span>
          </div>
          <div class="divTableCell w-220">
            <span v-if="record.approveStatus === 'APPROVED' && record.approvedDate">
              {{ new Date(record.approvedDate) | formatUTCDate }}
            </span>
          </div>
          <div class="divTableCell w-220">
            <span v-if="record.verificationStatus === 'VERIFIED' && record.verifiedDate">
              {{ new Date(record.verifiedDate) | formatUTCDate }}
            </span>
          </div>
          <div class="divTableCell w-220">
            <span v-if="record.signoffStatus === 'SIGNEDOFF' && record.signoffDate">
              {{ new Date(record.signoffDate) | formatUTCDate }}
            </span>
          </div>
          <div class="divTableCell w-220">
            <span v-if="record.reviewStatus === 'REVIEWED' && record.reviewedDate">
              {{ new Date(record.reviewedDate) | formatUTCDate }}
            </span>
          </div>
          <div class="divTableCell w-220">
            <span v-if="record.lockStatus === 'LOCKED' && record.lockedDate">
              {{ new Date(record.lockedDate) | formatUTCDate }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="displayMobileView === true">
      <div :class="{ 'loading-opacity': apiIsInProgress }" v-if="edcForms && edcForms.length > 0">
        <div class="card shadow rounded my-2" v-for="(record, index) in tasksArrOne" :key="index">
          <div class="card-body">
            <div class="text-info pt-4 pb-10">
              <span v-if="(isStudyTeam || canSupportAccess) && (record.label.toLowerCase() == 'missed' || record.label.toLowerCase() == 'pending' || record.label.toLowerCase() == 'start')">
                <span v-if="record.label != null" class="status disabled" :class="record.label.toLowerCase()">
                  {{ label[record.label] }}
                  <i v-if="record.label.toLowerCase() == 'start'" class="fa fa-play ml-5" aria-hidden="true"></i>
                </span>
              </span>
              <span v-else>
                <span @click="submitNewForm(record, $event)" v-if="record.label != null" class="status" :class="record.label.toLowerCase()">
                  {{ label[record.label] }}
                  <i v-if="record.label.toLowerCase() == 'start'" class="fa fa-play ml-5" aria-hidden="true"></i>
                </span>
              </span>
              <div
                :id="record.taskId"
                :class="{
                  'form-name-reschedule': record.label != null && record.label.toLowerCase() == 'reschedule',
                  'form-name': record.label != null && record.label.toLowerCase() != 'reschedule',
                  disabled: (record.label != null && (isStudyTeam || canSupportAccess) && (record.label.toLowerCase() == 'missed' || record.label.toLowerCase() == 'start')) || ((canNotViewDetailsOfPackets || canSupportAccess) && record.label.toLowerCase() == 'pending')
                }"
                @click="changeState(record)"
              >
                <span :id="`site-task-mob-${record.taskId}`" :title="record.taskName">{{ truncate(record) }}</span>
                <span class="ml-10" v-if="checkViewPermissions(record).canView == false"> <img width="20px" src="static/img/permission-eye.svg" alt v-b-popover.hover="'You do not have the permission to view this activity'" :popover-style="{ background: '#ffffff' }" />̥ </span>
                <!-- when archive list length is freator then 1 then show popover -->
                <b-tooltip :target="`site-task-mob-${record.taskId}`" placement="top" v-if="checkViewPermissions(record).canView" triggers="hover blur">{{ record.taskName }}</b-tooltip>
                <span v-if="record.archiveList && record.archiveList.length > 1 && canAccessArchiveList" @click="clickStopVisitModal()">
                  <span :id="record.taskId" tabindex="0" class="camera" v-if="record.taskType == 'TELEHEALTH_UNSCHEDULED' && record.archiveList != null">
                    <span
                      class="double-camera"
                      :class="{
                        'double-green': record.taskId == mainActiveArchiveId
                      }"
                      >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                    >
                  </span>
                  <span id="SITE_SCHEDULED_TELEHEALTH_2" tabindex="0" class="camera" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.archiveList != null">
                    <span
                      class="double-camera"
                      :class="{
                        'double-green': record.taskId == mainActiveArchiveId
                      }"
                      >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                    >
                  </span>
                  <b-popover v-if="record.taskId && record.taskType == 'SITE_SCHEDULED_TELEHEALTH'" :ref="'element' + record.taskId" target="SITE_SCHEDULED_TELEHEALTH_2" triggers="click blur">
                    <template v-slot:content>
                      <div @click="openRecording($event, record, archive, 'element' + record.taskId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                        <div class="open-recording mr-10">
                          {{ new Date(archive.startTime) | formatUTCDate }}
                        </div>
                        <span
                          class="blue-camera"
                          :class="{
                            'single-green': archive.archiveId == activeArchiveId
                          }"
                        ></span>
                      </div>
                    </template>
                  </b-popover>
                  <b-popover v-if="record.taskId && record.taskType != 'SITE_SCHEDULED_TELEHEALTH'" :ref="'element' + record.taskId" :target="record.taskId" triggers="click blur">
                    <template v-slot:content>
                      <div @click="openRecording($event, record, archive, 'element' + record.taskId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                        <div class="open-recording mr-10">
                          {{ new Date(archive.startTime) | formatUTCDate }}
                        </div>
                        <span
                          class="blue-camera"
                          :class="{
                            'single-green': archive.archiveId == activeArchiveId
                          }"
                        ></span>
                      </div>
                    </template>
                  </b-popover>
                </span>
                <!-- else show simple form of camera -->
                <span v-else>
                  <span v-if="record.archiveList && record.archiveList.length == 1 && (record.taskType == 'TELEHEALTH_UNSCHEDULED' || record.taskType == 'SITE_SCHEDULED_TELEHEALTH') && canAccessArchiveList" @click="openRecording($event, record, record.archiveList[0])" class="camera">
                    <span
                      class="single-camera"
                      :class="{
                        'single-green': record.taskId == mainActiveArchiveId
                      }"
                    ></span>
                  </span>
                </span>
                <span v-if="record.missedDueToMSSkip" class="skipped-task" aria-hidden="true" v-b-popover.hover="'Activity has been skipped due to change in study day'" :popover-style="{ background: '#ffffff' }">
                  <img alt="Activity Skipped" src="static/img/Icon_ Activity_Skipped.png" />
                </span>
              </div>
            </div>
            <span class="ml-5 ondemand-activity-icon" v-if="record.activitySchedulineMode && (record.activitySchedulineMode.toLowerCase() === 'ondemand' || record.activitySchedulineMode.toLowerCase() === 'both')">
              <img alt="Send Activity" src="static/img/participant-profile/send_activity_on.svg" />
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="no-task slide-animation" v-if="enableSiteTeamTable && edcForms.length == 0">
      No tasks available
    </div>
    <div class="show_all_div" v-if="enableSiteTeamTable && edcForms.length > 0">
      <div v-if="!isSiteTeamSectionExpand && enableSiteTeamTable && edcForms.length > 0 && showExpandButton" @click="isSiteTeamSectionExpand = !isSiteTeamSectionExpand" :class="isSiteTeamSectionExpand ? null : 'collapsed'" :aria-expanded="isSiteTeamSectionExpand" v-b-toggle.collapse-site-team variant="primary" class="toggle-text pt-10 pb-10">Show all tasks<span></span></div>
      <b-collapse v-if="enableSiteTeamTable" v-model="isSiteTeamSectionExpand" id="collapse-site-team" class="mt-2">
        <b-card v-if="displayMobileView === false">
          <div class="divTable">
            <div class="divTableBody" :class="{ 'loading-opacity': apiIsInProgress }">
              <div class="divTableRow" v-for="(record, index) in tasksArrTwo" :key="index">
                <div class="divTableCell text-info w-300">
                  <span v-if="(isStudyTeam || canSupportAccess) && (record.label.toLowerCase() == 'missed' || record.label.toLowerCase() == 'pending' || record.label.toLowerCase() == 'start' || isFormOrPacketRemoved(record))">
                    <span v-if="record.label != null" class="status disabled" :class="record.label.toLowerCase()">
                      {{ label[record.label] }}
                      <i v-if="record.label.toLowerCase() == 'start'" class="fa fa-play ml-5" aria-hidden="true"></i>
                    </span>
                  </span>
                  <span v-else>
                    <span @click="submitNewForm(record, $event)" v-if="record.label != null || record.label != ''" class="status" :class="record.label.toLowerCase()">
                      {{ label[record.label] }}
                      <i v-if="record.label.toLowerCase() == 'start'" class="fa fa-play ml-5" aria-hidden="true"></i>
                    </span>
                  </span>
                  <div
                    :id="record.taskId"
                    :class="{
                      'form-name-reschedule': record.label != null && record.label.toLowerCase() == 'reschedule',
                      'form-name': record.label != null && record.label.toLowerCase() != 'reschedule',
                      disabled: (record.label != null && (isStudyTeam || canSupportAccess) && (record.label.toLowerCase() == 'missed' || record.label.toLowerCase() == 'start')) || ((canNotViewDetailsOfPackets || canSupportAccess) && record.label.toLowerCase() == 'pending'),
                      'removed-form-name': isFormOrPacketRemoved(record)
                    }"
                    @click="changeState(record)"
                  >
                    <span :id="`site-task-show_all-${record.taskId}-${index}`" :title="record.taskName">{{ truncate(record) }}</span>
                    <span class="ml-10" v-if="checkViewPermissions(record).canView == false"> <img width="20px" src="static/img/permission-eye.svg" alt v-b-popover.hover="'You do not have the permission to view this activity'" :popover-style="{ background: '#ffffff' }" />̥ </span>
                    <img alt="" class="ml-10 visitPreSelectedIcon" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.responseId === null" @click="callVisitDetails(record)" src="static/img/telehealth/telehealth_comingUp.png" />
                    <img alt="Home Visit" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.responseId !== null && record.visitType === 'Homevisit'" class="visitTypeIconDisplay" @click="callVisitDetails(record)" src="static/img/telehealth/homeVisitLogo.svg" />
                    <img alt="Phone Call" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.responseId !== null && record.visitType === 'Phonecall'" class="visitTypeIconDisplay" @click="callVisitDetails(record)" src="static/img/telehealth/phonecallLogo.svg" />
                    <img alt="In Person" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.responseId !== null && record.visitType === 'In-person'" class="visitTypeIconDisplay" @click="callVisitDetails(record)" src="static/img/telehealth/office-visit-icon.svg" />
                    <img alt="Telehealth" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.responseId !== null && record.visitType === 'Telehealth'" class="visitTypeVideoCallIconDisplay" @click="callVisitDetails(record)" src="static/img/telehealth/video-call-icon.jpg" />
                    <b-tooltip :target="`site-task-show_all-${record.taskId}-${index}`" placement="top" triggers="hover blur" v-if="checkViewPermissions(record).canView">{{ record.taskName }}</b-tooltip>
                    <!-- when archive list length is freator then 1 then show popover -->
                    <span v-if="record.archiveList && record.archiveList.length > 1 && canAccessArchiveList" @click="clickStopVisitModal()">
                      <span :id="record.taskId" tabindex="0" class="camera" v-if="record.taskType == 'TELEHEALTH_UNSCHEDULED' && record.archiveList != null">
                        <span
                          class="double-camera"
                          :class="{
                            'double-green': record.taskId == mainActiveArchiveId
                          }"
                          >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                        >
                      </span>
                      <span id="SITE_SCHEDULED_TELEHEALTH_3" tabindex="0" class="camera" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.archiveList != null">
                        <span
                          class="double-camera"
                          :class="{
                            'double-green': record.taskId == mainActiveArchiveId
                          }"
                          >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                        >
                      </span>
                      <b-popover v-if="record.taskId && record.taskType == 'SITE_SCHEDULED_TELEHEALTH'" :ref="'element' + record.taskId" target="SITE_SCHEDULED_TELEHEALTH_3" triggers="click blur">
                        <template v-slot:content>
                          <div @click="openRecording($event, record, archive, 'element' + record.taskId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                            <div class="open-recording mr-10">
                              {{ new Date(archive.startTime) | formatUTCDate }}
                            </div>
                            <span
                              class="blue-camera"
                              :class="{
                                'single-green': archive.archiveId == activeArchiveId
                              }"
                            ></span>
                          </div>
                        </template>
                      </b-popover>
                      <b-popover v-if="record.taskId && record.taskType != 'SITE_SCHEDULED_TELEHEALTH'" :ref="'element' + record.taskId" :target="record.taskId" triggers="click blur">
                        <template v-slot:content>
                          <div @click="openRecording($event, record, archive, 'element' + record.taskId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                            <div class="open-recording mr-10">
                              {{ new Date(archive.startTime) | formatUTCDate }}
                            </div>
                            <span
                              class="blue-camera"
                              :class="{
                                'single-green': archive.archiveId == activeArchiveId
                              }"
                            ></span>
                          </div>
                        </template>
                      </b-popover>
                    </span>
                    <!-- else show simple form of camera -->
                    <span v-else>
                      <span v-if="record.archiveList && record.archiveList.length == 1 && (record.taskType == 'TELEHEALTH_UNSCHEDULED' || record.taskType == 'SITE_SCHEDULED_TELEHEALTH') && canAccessArchiveList" @click="openRecording($event, record, record.archiveList[0])" class="camera">
                        <span
                          class="single-camera"
                          :class="{
                            'single-green': record.taskId == mainActiveArchiveId
                          }"
                        ></span>
                      </span>
                    </span>
                    <span class="ml-5 ondemand-activity-icon" v-if="record.taskInstanceId && record.taskInstanceId.includes('on_demand')" data-toggle="modal" @click="onDemandModalshow(record)">
                      <img alt="Send Activity" src="static/img/participant-profile/send_activity_on.svg" />
                    </span>
                    <span v-if="record.missedDueToMSSkip" class="skipped-task" aria-hidden="true" v-b-popover.hover="'Activity has been skipped due to change in study day'" :popover-style="{ background: '#ffffff' }">
                      <img alt="Activity Skipped" src="static/img/Icon_ Activity_Skipped.png" />
                    </span>
                  </div>
                </div>

                <div class="divTableCell w-120">
                  <span v-if="record.state.toLowerCase() != 'complete' && record.dueDate && triggerForSiteTeamTask && record.scheduleDate != 0 && record.scheduleDate != null" class="due-date-indicator">{{ record.scheduleDate }}</span>
                  <span v-if="record.state.toLowerCase() != 'complete' && record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.scheduleDate != 0 && record.scheduleDate != null" class="due-date-indicator dueDateClass">{{ record.scheduleDate }}</span>
                </div>
                <div class="divTableCell w-220 color-text">
                  <div v-if="(record.label.toLowerCase() == 'pending' || record.label.toLowerCase() == 'complete' || record.label.toLowerCase() == 'cancelled' || record.label.toLowerCase() === 'reschedule') && record.responseTimeUTC != null">
                    <span>{{ new Date(record.responseTimeUTC) | formatUTCDate }}</span>
                    <span v-bind:id="`record.responseTimeUTC${index}`" class="clock ml-5"></span>
                    <b-popover v-bind:target="`record.responseTimeUTC${index}`" triggers="click blur">
                      <template v-slot:content>
                        <div class="popover-content">
                          <span class="clinic"></span>
                          <div class="ml-20 w-170 text-uppercase" v-html="toUserLocalTime(record.responseTimeUTC)"></div>
                        </div>
                      </template>
                    </b-popover>
                  </div>
                </div>
                <div class="divTableCell w-120 color-text">
                  {{ record.submittedBy }}
                </div>
                <div class="divTableCell  w-120 open-queries">
                  <span v-if="record.openQueryCount" class="open-query">{{ record.openQueryCount }}</span>
                </div>
                <div class="divTableCell  w-220">
                  <span v-if="record.approveStatus === 'APPROVED' && record.approvedDate">
                    {{ new Date(record.approvedDate) | formatUTCDate }}
                  </span>
                </div>
                <div class="divTableCell  w-220">
                  <span v-if="record.verificationStatus === 'VERIFIED' && record.verifiedDate"> {{ new Date(record.verifiedDate) | formatUTCDate }}</span>
                </div>
                <div class="divTableCell  w-220">
                  <span v-if="record.signoffStatus === 'SIGNEDOFF' && record.signoffDate"> {{ new Date(record.signoffDate) | formatUTCDate }}</span>
                </div>
                <div class="divTableCell  w-100 w-220">
                  <span v-if="record.reviewStatus === 'REVIEWED' && record.reviewedDate"> {{ new Date(record.reviewedDate) | formatUTCDate }}</span>
                </div>
                <div class="divTableCell  w-100 w-220">
                  <span v-if="record.lockStatus === 'LOCKED' && record.lockedDate"> {{ new Date(record.lockedDate) | formatUTCDate }}</span>
                </div>
              </div>
            </div>
          </div>
          <nav aria-label="page navigation pagination" v-if="isPaginationEnabled">
            <ul class="pagination">
              <li class="page-item">
                <a
                  @click="loadRecords($event, 'previous')"
                  :class="{
                    disabled: apiIsInProgress || this.localPaginationObject.currentPage == 1
                  }"
                  class="page-link arrow"
                  href="#"
                  >&#706;</a
                >
              </li>
              <li class="page-item">
                <a class="page-link">{{ this.localPaginationObject.currentPage }}</a>
              </li>
              <li class="page-item pt-1">
                <span class="of">of</span><span class="mr-3 ttlPge">{{ this.localPaginationObject.totalPage }}</span>
              </li>
              <li class="page-item">
                <a
                  @click="loadRecords($event, 'next')"
                  class="page-link arrow"
                  :class="{
                    disabled: apiIsInProgress || this.localPaginationObject.currentPage == this.localPaginationObject.totalPage
                  }"
                  href="#"
                  >></a
                >
              </li>
            </ul>
          </nav>
        </b-card>

        <div v-if="displayMobileView === true">
          <div :class="{ 'loading-opacity': apiIsInProgress }">
            <div class="card shadow rounded my-2" v-for="(record, index) in tasksArrTwo" :key="index">
              <div class="card-body">
                <div class="text-info py-2">
                  <span v-if="(isStudyTeam || canSupportAccess) && !!record.label && (record.label.toLowerCase() == 'missed' || record.label.toLowerCase() == 'pending' || record.label.toLowerCase() == 'start')">
                    <span v-if="record.label != null" class="status disabled" :class="!!record.label && record.label.toLowerCase()">
                      {{ label[record.label] }}
                      <i v-if="!!record.label && record.label.toLowerCase() == 'start'" class="fa fa-play ml-5" aria-hidden="true"></i>
                    </span>
                  </span>
                  <span v-else>
                    <span @click="submitNewForm(record, $event)" v-if="record.label != null || record.label != ''" class="status" :class="!!record.label && record.label.toLowerCase()">
                      {{ label[record.label] }}
                      <i v-if="!!record.label && record.label.toLowerCase() == 'start'" class="fa fa-play ml-5" aria-hidden="true"></i>
                    </span>
                  </span>
                  <div
                    :id="record.taskId"
                    :class="{
                      'form-name-reschedule': record.label != null && record.label.toLowerCase() == 'reschedule',
                      'form-name': record.label != null && record.label.toLowerCase() != 'reschedule',
                      disabled: (record.label != null && (isStudyTeam || canSupportAccess) && (record.label.toLowerCase() == 'missed' || record.label.toLowerCase() == 'start')) || ((canNotViewDetailsOfPackets || canSupportAccess) && record.label.toLowerCase() == 'pending')
                    }"
                    @click="changeState(record)"
                  >
                    <span :id="`site-task${record.taskId}`" :title="record.taskName">{{ truncate(record) }}</span>
                    <span class="ml-10" v-if="checkViewPermissions(record).canView == false"> <img width="20px" src="static/img/permission-eye.svg" alt v-b-popover.hover="'You do not have the permission to view this activity'" :popover-style="{ background: '#ffffff' }" />̥ </span>
                    <b-tooltip :target="`site-task${record.taskId}`" v-if="checkViewPermissions(record).canView" placement="top" triggers="hover blur">{{ record.taskName }}</b-tooltip>
                    <!-- when archive list length is freator then 1 then show popover -->
                    <span v-if="record.archiveList && record.archiveList.length > 1 && canAccessArchiveList" @click="clickStopVisitModal()">
                      <span :id="record.taskId" tabindex="0" class="camera" v-if="record.taskType == 'TELEHEALTH_UNSCHEDULED' && record.archiveList != null">
                        <span
                          class="double-camera"
                          :class="{
                            'double-green': record.taskId == mainActiveArchiveId
                          }"
                          >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                        >
                      </span>
                      <span id="SITE_SCHEDULED_TELEHEALTH_4" tabindex="0" class="camera" v-if="record.taskType == 'SITE_SCHEDULED_TELEHEALTH' && record.archiveList != null">
                        <span
                          class="double-camera"
                          :class="{
                            'double-green': record.taskId == mainActiveArchiveId
                          }"
                          >{{ record.archiveList != null && record.archiveList.length > 1 ? record.archiveList.length : "" }}</span
                        >
                      </span>
                      <b-popover v-if="record.taskId && record.taskType == 'SITE_SCHEDULED_TELEHEALTH'" :ref="'element' + record.taskId" target="SITE_SCHEDULED_TELEHEALTH_4" triggers="click blur">
                        <template v-slot:content>
                          <div @click="openRecording($event, record, archive, 'element' + record.taskId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                            <div class="open-recording mr-10">
                              {{ new Date(archive.startTime) | formatUTCDate }}
                            </div>
                            <span
                              class="blue-camera"
                              :class="{
                                'single-green': archive.archiveId == activeArchiveId
                              }"
                            ></span>
                          </div>
                        </template>
                      </b-popover>
                      <b-popover v-if="record.taskId && record.taskType != 'SITE_SCHEDULED_TELEHEALTH'" :ref="'element' + record.taskId" :target="record.taskId" triggers="click blur">
                        <template v-slot:content>
                          <div @click="openRecording($event, record, archive, 'element' + record.taskId, index)" class="popover-camera-content" v-for="(archive, index) in record.archiveList" :key="index">
                            <div class="open-recording mr-10">
                              {{ new Date(archive.startTime) | formatUTCDate }}
                            </div>
                            <span
                              class="blue-camera"
                              :class="{
                                'single-green': archive.archiveId == activeArchiveId
                              }"
                            ></span>
                          </div>
                        </template>
                      </b-popover>
                    </span>
                    <!-- else show simple form of camera -->
                    <span v-else>
                      <span v-if="record.archiveList && record.archiveList.length == 1 && (record.taskType == 'TELEHEALTH_UNSCHEDULED' || record.taskType == 'SITE_SCHEDULED_TELEHEALTH') && canAccessArchiveList" @click="openRecording($event, record, record.archiveList[0])" class="camera">
                        <span
                          class="single-camera"
                          :class="{
                            'single-green': record.taskId == mainActiveArchiveId
                          }"
                        ></span>
                      </span>
                    </span>
                    <span v-if="record.missedDueToMSSkip" class="skipped-task" aria-hidden="true" v-b-popover.hover="'Activity has been skipped due to change in study day'" :popover-style="{ background: '#ffffff' }">
                      <img alt="Activity Skipped" src="static/img/Icon_ Activity_Skipped.png" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <nav aria-label="page navigation pagination" v-if="isPaginationEnabled">
            <ul class="pagination hiii">
              <li class="page-item">
                <a
                  @click="loadRecords($event, 'previous')"
                  :class="{
                    disabled: apiIsInProgress || this.localPaginationObject.currentPage == 1
                  }"
                  class="page-link arrow"
                  href="#"
                  >&#706;</a
                >
              </li>
              <li class="page-item">
                <a class="page-link">{{ this.localPaginationObject.currentPage }}</a>
              </li>
              <li class="page-item pt-1">
                <span class="of">of</span><span class="mr-3 ttlPge">{{ this.localPaginationObject.totalPage }}</span>
              </li>
              <li class="page-item">
                <a
                  @click="loadRecords($event, 'next')"
                  class="page-link arrow"
                  :class="{
                    disabled: apiIsInProgress || this.localPaginationObject.currentPage == this.localPaginationObject.totalPage
                  }"
                  href="#"
                  >></a
                >
              </li>
            </ul>
          </nav>
        </div>
        <div v-if="!isPaginationEnabled && showCollapseButton" @click="isSiteTeamSectionExpand = !isSiteTeamSectionExpand" v-b-toggle.collapse-site-team variant="primary" class="toggle-text pb-10 pt-15">Collapse tasks<span class="collapsed"></span></div>
      </b-collapse>
    </div>
    <ScheduleVisitSiteTeam
      v-if="showScheduleVisit"
      :modalType="siteSchedulemodalType"
      :mapVisitsData="mapVisitsData"
      :participantInfo="participantInfo"
      :appointmentDetails="appointmentDetails"
      :piDetails="piDetails"
      :studyId="studyId"
      :visitConfiguredDetails="visitConfiguredDetails"
      :siteTeamSelectedTaskDetails="siteTeamSelectedTaskDetails"
      :siteDetailsInfo="siteDetailsInfo"
      @scheduledVisitData="getConfiguredVisitData"
      @cancelEvent="cancelModal()"
      @cancelVisitEvent="cancelVisitDataEvent"
    />
    <b-modal ref="visitTypeDataViewModal" id="visit-type-data-view-modal" no-close-on-backdrop hide-footer hide-header body-class="modal-body-custom pt-0">
      <div class="clearfix"></div>
      <div class="activityNameLayout">
        <b
          ><p class="fs-16 pl-10 pr-10 pt-15" v-if="visitTypeDetails.record">{{ visitTypeDetails.record.taskName }}<br /></p
        ></b>
      </div>
      <div>
        <b-row class="rowDiv pt-10 pb-10">
          <b-col cols="4">
            <div class="subHeading pb-5">Participant ID</div>
            <div style="word-break:break-all;">
              {{ visitTypeDetails.participantId }}
            </div>
          </b-col>
          <b-col cols="8">
            <div class="subHeading pb-5">THREAD ID</div>
            <div>{{ visitTypeDetails.threadId }}</div>
          </b-col>
        </b-row>
      </div>
      <div v-if="visitTypeDetails.visitType === 'homevisit'">
        <div class="mt-20">
          <span class="evaluateAddressField">Visit Address </span>
        </div>
        <div class="w-200">
          <span class="evaluateModalPhnoField">
            {{ showVisitAddress(visitTypeDetails.details) }}
          </span>
        </div>
      </div>
      <div v-if="visitTypeDetails.visitType === 'phonecall'">
        <div class="mt-20">
          <span class="evaluateAddressField">Phone Number</span>
        </div>
        <div class="w-200">
          <span class="evaluateModalPhnoField">
            <span v-if="visitTypeDetails.details.countryCode != null">{{ visitTypeDetails.details.countryCode }} </span>
            <span v-if="visitTypeDetails.details.phoneNumber != null">{{ visitTypeDetails.details.phoneNumber }}</span>
          </span>
        </div>
      </div>
      <div class="mt-10" style="float:right;">
        <div style="display:flex;">
          <span class="cancelText mr-20 mt-10" @click="closeScreen()">Cancel</span>
          <button class="btn btn-primary" :disabled="editVisitBtnDisabled" @click="editVisit()">
            <span class="fs-13" @click="editVisit()">Edit Visit</span>
          </button>
        </div>
      </div>
    </b-modal>

    <div class="modal fade" id="cancleOnDemondModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <div class="cancle-activity-title">{{ copyRecord.taskName }}</div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="copyRecord.state === 'Scheduled' || copyRecord.state === ''">
            <button class="mt-3 activity-cancel-btn" data-toggle="modal" @click="cancleOnDemoanActivity()">
              Cancel
            </button>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="table-responsive">
                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th class="heading-title">DATE/TIME SENT</th>
                      <th class="heading-title">USER SENT</th>
                      <th class="heading-title">DATE/TIME CANCELLED</th>
                      <th class="heading-title">USER CANCELLED</th>
                      <th class="heading-title">REASON FOR CANCELLATION</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(field, index) in onDemandActivityDetails" :key="index">
                      <td>{{ field.sentDate | formatUTCDate }}</td>
                      <td>{{ field.sentBy }}</td>
                      <td>
                        <span v-if="field.withdrawnDateUtc">{{ field.withdrawnDateUtc | formatUTCDate }}</span>
                      </td>
                      <td>{{ field.withdrawnBy }}</td>
                      <td>{{ field.withdrawnReason }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="addCancleReason" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="cancle-activity-name">Cancel Activity</div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="text-message">
            Are you sure you want to cancel? Canceling an activity will remove it from the participant’s study app. This action cannot be undone.
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <label class="reason-label">Reason for cancellation <span class="optional">(optional)</span></label>
              <input class="withdrawn-reason" type="text" v-model="withdrawnReason" name="withdrawnReason" />
              <div class="row">
                <button type="button" class="btn btn-no" @click="cancleActivityModal()">
                  No
                </button>
                <button type="button" class="btn btn-yes" @click="deleteOnDemondActivity()">
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
import _ from "lodash";
import $ from "jquery";
import nprogress from "nprogress";
import { PI, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, CRA, DM, QUALITY, SITEDATALOCK, BSTAT, PHV, RATER, INTERVIEWER, CC, CraUB, SUPPORT } from "@/constants/authRoles";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import * as constant from "../../constants/config";
import ScheduleVisitSiteTeam from "../participants/telehealth/schedule-visit-siteteam.vue";
import MultilingualService from "@/components/services/multilingual-service";
import localStorageService from "@/services/localStorage";
import toastr from "toastr";
export default {
  name: "site-team-action-table",
  components: {
    ScheduleVisitSiteTeam
  },
  props: {
    edcFormRecords: {
      type: Array
    },
    studyId: {
      type: String
    },
    siteTeamTaskCompletionPR: {},
    enableSiteTeamTable: {
      type: Boolean
    },
    sitePaginationObject: {
      type: Object
    },
    showAllSiteTeamTasks: {
      type: Boolean,
      default: false
    },
    siteTableDataLoading: {
      type: Boolean,
      default: false
    },
    siteTeamTaskSectionEnabled: {
      type: Boolean
    },
    triggerForSiteTeamTask: {
      type: Boolean
    },
    milestoneView: {
      type: Boolean
    },
    participantInfo: {
      type: Object
    },
    studyResponse: {
      type: Object
    },
    showHideCompliance: {
      type: Boolean
    }
  },

  data() {
    return {
      mlService: new MultilingualService(this.$route),
      siteTeamActionFields: [
        {
          key: "taskName",
          type: "string",
          label: "Name",
          ascOrder: false,
          dscOrder: false,
          class: "w-300 pl-85",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "scheduleDate",
          type: "integer",
          label: "Due",
          ascOrder: false,
          dscOrder: false,
          class: "w-120",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "responseTimeUTC",
          type: "integer",
          label: "Completed/Last Modified",
          ascOrder: false,
          dscOrder: false,
          class: "w-200",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "submittedBy",
          type: "string",
          label: "By",
          ascOrder: false,
          dscOrder: false,
          class: "w-120",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "openQueryCount",
          type: "integer",
          label: "Open Queries",
          ascOrder: false,
          dscOrder: false,
          class: "w-120 open-queries",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "approveStatus",
          type: "integer",
          label: "Approved",
          ascOrder: false,
          dscOrder: false,
          class: "w-90 ql-align-center",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "verificationStatus",
          type: "integer",
          label: "Verified",
          ascOrder: false,
          dscOrder: false,
          class: "w-75 ql-align-center",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "signoffStatus",
          type: "integer",
          label: "Signed off",
          ascOrder: false,
          dscOrder: false,
          class: "w-100 ql-align-center",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "reviewStatus",
          type: "integer",
          label: "Reviewed",
          ascOrder: false,
          dscOrder: false,
          class: "w-100 ql-align-center",
          currentOrder: null,
          ableToSort: true
        },
        {
          key: "lockStatus",
          type: "integer",
          label: "Locked",
          ascOrder: false,
          dscOrder: false,
          class: "w-100 ql-align-center",
          currentOrder: null,
          ableToSort: true
        }
      ],
      label: {
        NotStarted: "Not Started",
        Cancelled: "Cancelled",
        Missed: "Missed",
        NOTSTARTED: "Not Started",
        Complete: "Complete",
        Pending: "Pending",
        Start: "Start",
        Scheduled: "Schedule",
        Reschedule: "Rescheduled",
        Removed: "Removed"
      },
      isSiteTeamSectionExpand: false,
      edcForms: [],
      localPaginationObject: {},
      isPaginationEnabled: false,
      apiIsInProgress: false,
      showCollapseButton: false,
      showExpandButton: false,
      activeArchiveId: null,
      mainActiveArchiveId: null,
      displayMobileView: Boolean,
      showScheduleVisit: false,
      mapVisitsData: {},
      visitTypeDetails: {},
      piDetails: {},
      siteTeamSelectedTaskDetails: {},
      appointmentDetails: {},
      siteSchedulemodalType: "",
      editVisitBtnDisabled: false,
      visitConfiguredDetails: {},
      siteDetailsInfo: {},
      showScheduleVisitModal: true,
      onDemandActivityDetails: [],
      copyRecord: {},
      withdrawnReason: ""
    };
  },
  created() {
    if (constant.SCREENWIDTH > 767) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  watch: {
    siteTableDataLoading: {
      handler(val) {
        if (val) {
          this.apiIsInProgress = true;
        }
      }
    },
    edcFormRecords: {
      handler() {
        if (this.showAllSiteTeamTasks) {
          this.isSiteTeamSectionExpand = true;
        } else {
          this.isSiteTeamSectionExpand = false;
        }
        this.edcForms = _.cloneDeep(this.edcFormRecords);
        this.edcForms.forEach(form => {
          const scheduleDate = moment(form.scheduleDate).add("days", form.duration);
          form.scheduleDate = scheduleDate.format("DD MMM YYYY");
        });
        // disabled sorting if scheduled / due task is not there
        const disabledSortingForCompletedColumn = this.edcForms.filter(f => {
          if (f.label != null) {
            return f.label.toLowerCase() == "pending" || f.label.toLowerCase() == "complete" || f.label.toLowerCase() == "cancelled";
          }
        });
        const disabledSortingForDueColumn = this.edcForms.filter(f => {
          return f.dueDate == true;
        });
        const disabledSortingForBy = this.edcForms.filter(f => {
          return f.submittedBy != null && f.submittedBy != "";
        });
        const disabledSortingForOpenQueries = this.edcForms.filter(f => {
          return f.openQueryCount != 0;
        });
        const disabledSortingForApproved = this.edcForms.filter(f => {
          return f.approveStatus == "APPROVED";
        });
        const disabledSortingForVerified = this.edcForms.filter(f => {
          return f.verificationStatus == "VERIFIED";
        });
        const disabledSortingForReviewed = this.edcForms.filter(f => {
          return f.reviewStatus == "REVIEWED";
        });
        const disabledSortingForSignedOff = this.edcForms.filter(f => {
          return f.signoffStatus == "SIGNEDOFF";
        });
        const disabledSortingForLocked = this.edcForms.filter(f => {
          return f.lockStatus == "LOCKED";
        });
        this.siteTeamActionFields.map(field => {
          if (field.key == "scheduleDate") {
            field.ableToSort = disabledSortingForDueColumn.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "responseTimeUTC") {
            field.ableToSort = disabledSortingForCompletedColumn.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "submittedBy") {
            field.ableToSort = disabledSortingForBy.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "openQueryCount") {
            field.ableToSort = disabledSortingForOpenQueries.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "approveStatus") {
            field.ableToSort = disabledSortingForApproved.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "verificationStatus") {
            field.ableToSort = disabledSortingForVerified.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "reviewStatus") {
            field.ableToSort = disabledSortingForReviewed.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "signoffStatus") {
            field.ableToSort = disabledSortingForSignedOff.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
          if (field.key == "lockStatus") {
            field.ableToSort = disabledSortingForLocked.length > 0;
            field.ascOrder = false;
            field.dscOrder = false;
          }
        });
      }
    },
    sitePaginationObject: {
      handler(val) {
        this.apiIsInProgress = false;
        if ((val.totalPage == 1 || val.totalPage == 0) && val.totalRecords <= 5) {
          this.isPaginationEnabled = false;
          this.showCollapseButton = false;
          this.showExpandButton = false;
          return;
        } else if ((val.totalPage == 1 || val.totalPage == 0) && val.totalRecords > 5) {
          this.isPaginationEnabled = false;
          this.showCollapseButton = true;
          this.showExpandButton = true;
          return;
        } else if (val.totalPage > 1) {
          this.isPaginationEnabled = true;
          this.showCollapseButton = false;
          this.showExpandButton = true;
        }
        this.prepareSiteObject();
      }
    }
  },
  computed: {
    ...mapGetters(["token", "user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canCraAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canDmAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canAccessArchiveList() {
      return this.canHomeHealthAccess || this.canCallCenterAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.canInterviewerAccess || this.canRaterAccess || this.canSiteDataLockAccess;
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPIAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canInterviewerAccess() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    canBioStatisticsAccess() {
      this.$acl.change(`${BSTAT}`);
      return this.$acl.check("userAccess");
    },
    canPharmacovigilanceAccess() {
      this.$acl.change(`${PHV}`);
      return this.$acl.check("userAccess");
    },
    canSupportAccess() {
      this.$acl.change(`${SUPPORT}`);
      return this.$acl.check("userAccess");
    },
    tasksArrOne() {
      return this.edcForms.slice(0, 5);
    },
    tasksArrTwo() {
      return this.edcForms.slice(5, this.edcForms.length);
    },
    isStudyTeam() {
      return this.canCraAccess || this.canDmAccess || this.canQualityAccess || this.canSiteDataLockAccess || this.canPharmacovigilanceAccess || this.canBioStatisticsAccess || this.user.readOnly || this.canCraUBAccess;
    },
    canNotViewDetailsOfPackets() {
      return this.canCraAccess || this.canDmAccess || this.canQualityAccess || this.canSiteDataLockAccess || this.canPharmacovigilanceAccess || this.canBioStatisticsAccess || this.user.readOnly;
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    }
  },
  methods: {
    onDemandModalshow(record) {
      this.withdrawnReason = "";
      this.copyRecord = record;
      if (this.copyRecord.label.toLowerCase() === "missed" || this.copyRecord.label.toLowerCase() === "start") {
        return;
      }
      if (this.copyRecord.state === "" || this.copyRecord.state === "Cancelled" || this.copyRecord.state === "Scheduled") {
        this.getDeletedRecordOfOnDemond();
        $("#cancleOnDemondModal").modal("show");
      }
    },
    getDeletedRecordOfOnDemond() {
      this.onDemandActivityDetails = [];
      this.$api.getDeleteOnDemondActivityFact(this.$route.params.studyId, this.copyRecord.studyVersionId, this.copyRecord.taskInstanceId, this.$route.params.participantId).then(
        response => {
          this.onDemandActivityDetails.push(response.body);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting record.");
        }
      );
    },
    onDemandModalHide() {
      this.$root.$emit("bv::hide::modal", "onDemandActivity", "#btnOnDemand");
    },
    cancleOnDemoanActivity() {
      $("#cancleOnDemondModal").modal("hide");
      $("#addCancleReason").modal("show");
    },
    deleteOnDemondActivity() {
      const userObj = localStorageService.getItem("userObj");
      const data = {
        id: this.copyRecord.id,
        participantId: this.copyRecord.participantId,
        studyId: this.copyRecord.studyId,
        studyVersionId: this.copyRecord.studyVersionId,
        taskId: this.copyRecord.taskId,
        taskInstanceId: this.copyRecord.taskInstanceId,
        sentBy: this.onDemandActivityDetails && this.onDemandActivityDetails.length ? this.onDemandActivityDetails[0].sentBy : "",
        taskType: this.copyRecord.taskType,
        taskTitle: this.copyRecord.taskName,
        withdrawnReason: this.withdrawnReason,
        withdrawnBy: userObj.id,
        withdrawnDateUtc: new Date(),
        participantCurrentDay: this.copyRecord.participantCurrentDay,
        status: this.copyRecord.state ? this.copyRecord.state : "",
        startDay: null,
        endDay: null,
        milestoneId: null
      };
      this.$api.postDeleteOnDemondActivityFact(this.$route.params.studyId, data).then(
        () => {
          this.$emit("refreshSiteTaskList");
          toastr.success("Activity cancelled successfully.");
          $("#addCancleReason").modal("hide");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while deleting record.");
        }
      );
    },
    cancleActivityModal() {
      $("#addCancleReason").modal("hide");
    },
    submitNewForm(record, event) {
      event.stopPropagation();
      if (record.label.toLowerCase() == "start" || record.taskType === "SITE_SCHEDULED_TELEHEALTH") {
        this.changeState(record);
      }
    },
    prepareSiteObject() {
      this.localPaginationObject = _.cloneDeep(this.sitePaginationObject);
    },
    loadRecords(event, direction) {
      event.preventDefault();
      if (this.apiIsInProgress) {
        return;
      }
      if (direction == "next") {
        if (this.localPaginationObject.currentPage == this.localPaginationObject.totalPage) {
          return;
        } else {
          this.apiIsInProgress = true;
          const currentPage = this.localPaginationObject.currentPage + 1;
          this.localPaginationObject.currentIndex += 10;
          const obj = {
            pageIndex: currentPage,
            pageSize: 10,
            totalRecords: this.localPaginationObject.totalRecords,
            totalPage: this.localPaginationObject.totalPage
          };
          this.$emit("getNextSiteTeamRecords", obj);
        }
      } else if (direction == "previous") {
        if (this.localPaginationObject.currentPage == 1) {
          return;
        } else {
          this.apiIsInProgress = true;
          const currentPage = this.localPaginationObject.currentPage - 1;
          this.localPaginationObject.currentIndex = this.localPaginationObject.currentIndex + 1 - 10;
          const obj = {
            pageIndex: currentPage,
            pageSize: 10,
            totalRecords: this.localPaginationObject.totalRecords,
            totalPage: this.localPaginationObject.totalPage
          };
          this.$emit("getNextSiteTeamRecords", obj);
        }
      }
    },
    sortField(field, direction) {
      if (!field.ableToSort || this.edcForms.length == 0) {
        return;
      }
      if (direction == "asc") {
        field.ascOrder = true;
        field.dscOrder = false;
      } else if (direction == "desc") {
        field.ascOrder = false;
        field.dscOrder = true;
      }
      if (field.type == "string") {
        if (field.currentOrder != direction) {
          field.currentOrder = direction;
          this.sortString(direction, field);
        }
      } else if (field.type == "integer" && field.currentOrder != direction) {
        field.currentOrder = direction;
        this.sortTimeStamp(direction, field);
      }
    },
    sortString(direction, field) {
      let records = _.cloneDeep(this.edcForms);
      records = _.orderBy(records, [records => records[field.key] != undefined && records[field.key].toLowerCase()], direction);
      this.edcForms = records;
    },
    sortTimeStamp(direction, field) {
      let records = _.cloneDeep(this.edcForms);
      records = _.orderBy(records, [records => records[field.key] != undefined && records[field.key]], direction);
      this.edcForms = records;
    },
    changeState(record) {
      if (record.label == "" || record.label.toLowerCase() == "cancelled") {
        return;
      }
      if (this.triggerDay && this.triggerDay.isTriggeredFeatureEnabled && this.triggerDay.triggeredBtnVisiblity && record.taskType == "TELEHEALTH_UNSCHEDULED" && record.taskType == "EDC_SCHEDULED") {
        return;
      }
      if (!this.triggerForSiteTeamTask && record.taskType == "EDC_SCHEDULED") {
        return;
      }
      if (((this.isStudyTeam || this.canSupportAccess) && (record.label.toLowerCase() == "missed" || record.label.toLowerCase() == "start" || record.label.toLowerCase() == "cancelled")) || ((this.canNotViewDetailsOfPackets || this.canSupportAccess) && record.label.toLowerCase() == "pending") || this.isFormOrPacketRemoved(record)) {
        return;
      }
      if (this.participantInfo.status === "WITHDRAWSTUDY" || this.participantInfo.status === "DISQUALIFIED" || this.participantInfo.status === "DISCONTINUED") {
        if (!record.navigate && record.taskType == "SITE_SCHEDULED_TELEHEALTH") {
          this.$swal({
            title: "This activity cannot be completed as the participant no longer has access to the study.",
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#1e8fe1",
            confirmButtonText: "OK"
          }).then(() => {});
          return;
        }
      }

      if (record.taskType == "SITE_SCHEDULED_TELEHEALTH" && (record.responseId === null || record.responseId === "")) {
        if (this.canPiAccess || this.canSubPIAccess || this.canStudyCoordinatorAccess || this.canHomeHealthAccess) {
          this.siteSchedulemodalType = "preScheduleVisit";
          this.getVisitConfigDetails(this.studyId, record);
        }
      } else if (record.taskType == "SITE_SCHEDULED_TELEHEALTH" && record.responseId != null) {
        if (this.canPiAccess || this.canSubPIAccess || this.canStudyCoordinatorAccess || this.canHomeHealthAccess || this.canCraUBAccess) {
          this.siteSchedulemodalType = "postScheduleVisit";
          this.showVisitDetails(record);
          this.getVisitConfigDetails(this.studyId, record);
        }
      }

      //if unscheduled packet is not Submitted
      if (record.taskType == "EDC_UNSCHEDULED" && record.state !== "SUBMITTED") {
        const params = {
          studyId: this.studyId,
          packetId: record.taskId,
          unscheduledPacketResponseId: record.responseId,
          responseType: "UNSCHEDULED",
          label: record.label.toLowerCase()
        };
        this.$router.push({
          name: "study-participant-edc-unschedule-packet-reskin",
          params: params
        });
      }
      //if unscheduled Packet is Submitted
      else if (record.taskType == "EDC_UNSCHEDULED" && record.state === "SUBMITTED") {
        const params = {
          studyId: this.studyId,
          packetId: record.taskId,
          unscheduledPacketResponseId: record.responseId,
          responseType: "UNSCHEDULED",
          milestone: record.scheduleDay || 0,
          taskInstanceId: 0,
          label: record.label.toLowerCase()
        };
        this.$router.push({ name: "submitted-packets-reskin", params: params });
      }
      // if scheduled Packet is Not submitted
      else if (record.taskType == "EDC_SCHEDULED_PACKET" && record.state !== "SUBMITTED") {
        const params = {
          studyId: this.studyId,
          milestone: record.scheduleDay || 0,
          packetId: record.taskId,
          unscheduledPacketResponseId: record.responseId || "0",
          responseType: "SCHEDULED",
          taskInstanceId: record.taskInstanceId,
          label: record.label.toLowerCase()
        };
        this.$router.push({
          name: "study-participant-edc-unschedule-form-reskin",
          params: params
        });
      }
      // if scheduled Packet is Submitted
      else if (record.taskType == "EDC_SCHEDULED_PACKET" && record.state === "SUBMITTED") {
        const params = {
          studyId: this.studyId,
          milestone: record.scheduleDay || 0,
          packetId: record.taskId,
          unscheduledPacketResponseId: record.responseId,
          responseType: "SCHEDULED",
          taskInstanceId: record.taskInstanceId,
          label: record.label.toLowerCase()
        };
        this.$router.push({ name: "submitted-packets-reskin", params: params });
      }

      //If it is a Form
      else {
        //IF there is no permission to view the form
        if (this.checkViewPermissions(record).canView == false) {
          return;
        }

        if (record.taskType != "SITE_SCHEDULED_TELEHEALTH") {
          const query = {
            canView: this.checkViewPermissions(record).canView,
            canComplete: this.checkViewPermissions(record).canComplete
          };

          //If form is Complete
          if ((record.taskType == "FORM_UNSCHEDULED" || record.taskType == "EDC_SCHEDULED") && record.state == "SUBMITTED") {
            const params = {
              studyId: this.studyId,
              formId: record.taskId,
              milestone: record.scheduleDay,
              responseId: record.responseId || "0",
              label: record.label.toLowerCase()
            };
            query.type = record.taskType;
            this.$router.push({
              name: "submitted-form-new",
              params: params,
              query: query
            });
          }

          //if Form is Missed
          else if (record.taskType == "EDC_SCHEDULED" && record.state !== "SUBMITTED") {
            const params = {
              studyId: this.studyId,
              formId: record.taskId,
              milestone: record.scheduleDay,
              responseId: record.responseId || "0",
              label: record.label.toLowerCase(),
              taskInstanceId: record.taskInstanceId
            };

            this.$router.push({
              name: "study-participant-edc-reskin",
              params: params,
              query: query
            });
          }
        }
      }
    },
    checkViewPermissions(activity) {
      let currentRole;

      switch (this.userAccess[0][0]) {
        case "Pi":
          currentRole = "Principal-Investigator";
          break;
        case "HomeHealth":
          currentRole = "Home-Health";
          break;
        case "SubPi":
          currentRole = "Sub-Investigator";
          break;
        case "StudyCoordinator":
          currentRole = "Study-Coordinator";
          break;
        case "SiteDataLock":
          currentRole = "Site-DataLock";
          break;
        case "Rater":
          currentRole = "Rater";
          break;
        case "Cra":
          currentRole = "CRA";
          break;
        case "CraUB":
          currentRole = "CraUB";
          break;
        case "Dm":
          currentRole = "Data-Management";
          break;
        case "CallCenter":
          currentRole = "Call-Center";
          break;
        case "Quality":
          currentRole = "Quality";
          break;
        case "Biostatistics":
          currentRole = "Biostatistics";
          break;
        case "Interviewer":
          currentRole = "Interviewer";
          break;
        case "Pharmacovigilance":
          currentRole = "Pharmacovigilance";
          break;
        case "Support":
          currentRole = "Support";
          break;
      }

      let canView;
      // if the role is Admin
      if (this.user && (this.user.userRole == "StudyAdmin" || this.user.userRole == "SystemAdmin" || this.user.userRole == "Support")) {
        canView = true;
      } else {
        if (activity.viewPermissions && activity.viewPermissions.length) {
          const canViewArr = activity.viewPermissions.split(",");
          canView = canViewArr.some(user => user == currentRole);
        } else {
          canView = true;
        }
      }

      let canComplete;
      // if the role is Admin
      if (this.user && (this.user.userRole == "StudyAdmin" || this.user.userRole == "SystemAdmin")) {
        canComplete = true;
      } else {
        if (activity.completePermissions && activity.completePermissions.length) {
          const canCompleteArr = activity.completePermissions.split(",");
          canComplete = canCompleteArr.some(user => user == currentRole);
        } else if (this.canSupportAccess) {
          canComplete = false;
        } else {
          canComplete = true;
        }
      }

      return { canView, canComplete };
    },
    truncate(record) {
      const len = record.taskType == "TELEHEALTH_UNSCHEDULED" ? 14 : 16;
      let string = null;
      if (record.taskName.length > len) {
        string = _.cloneDeep(record.taskName);
        return string.substring(0, len) + "...";
      }
      return string == null ? record.taskName : string;
    },
    openRecording(event, record, archive, element = null, index = null) {
      event.stopPropagation();
      if (this.$root.recordingPage.pageName != null && this.$root.recordingPage.pageName != "siteTeamTable") {
        this.$toastr.error("Another recording is currently playing.");
        return;
      }
      if (this.mainActiveArchiveId && this.mainActiveArchiveId != record.taskId) {
        this.$toastr.error("Another recording is currently playing.");
        return;
      }
      if (this.$root.telehealthStarted) {
        this.$toastr.error("Call is in progress. Please try later.");
        return;
      }
      this.$root.recordingPage = { pageName: "siteTeamTable" };
      this.activeArchiveId = archive && archive.archiveId;
      this.mainActiveArchiveId = record.taskId;
      this.getArchiveUrl(archive, record, element, index);
    },
    getArchiveUrl(archive, record, element, index = null) {
      this.$api.getArchiveUrl(this.studyId, archive.archiveId).then(response => {
        if (response.body) {
          const obj = {
            archiveListLength: record.archiveList.length,
            type: "fullScreen",
            archiveUrl: response.body,
            archiveId: archive.archiveId,
            telehealthName: record.taskName,
            recordDate: archive.startTime,
            archiveList: record.archiveList.length > 1 ? record.archiveList : null,
            archiveIndex: index + 1
          };
          // hide the popover
          if (element != null) {
            this.$refs[element][0].$emit("close");
          }
          this.$root.$emit("playBackVideoStarted", obj);
        } else {
          this.$toastr.error("Archive is not available at this point. Please try again later.");
          if (element != null) {
            this.$refs[element][0].$emit("close");
          }
        }
      });
    },
    toUserLocalTime(timeString) {
      const localObj = moment.utc(timeString).local();
      const formatedTime = localObj.format("DD MMM YYYY hh:mm");
      const meridiem = localObj.format("A");

      const timeZone = moment.tz.guess();
      const time = new Date();
      const timeZoneOffset = time.getTimezoneOffset();
      const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
      return `${formatedTime} ${meridiem} ${abbr}`;
    },
    openSchedule() {
      this.showScheduleVisit = true;
    },
    cancelModal() {
      this.showScheduleVisit = false;
    },
    getConfiguredVisitData(data) {
      this.showScheduleVisit = false;
      if (this.siteSchedulemodalType === "preScheduleVisit") {
        this.$api.scheduleAppointmentParticipantFact(data).then(
          response => {
            if (response.body) {
              this.$toastr.success("Visit scheduled successfully");
              const dataObj = {
                totalRecords: this.localPaginationObject.totalRecords,
                totalPage: this.localPaginationObject.totalPage,
                pageIndex: this.localPaginationObject.currentPage
              };
              this.$emit("updatetSiteTeamRecords", dataObj);
            }
          },
          err => {
            this.$toastr.error(err.body.message);
          }
        );
      } else {
        if (this.checkforRescheduleFlag(data)) {
          this.$api.reScheduleAppointmentParticipantFact(this.siteTeamSelectedTaskDetails.responseId, data).then(
            response => {
              if (response.body) {
                this.$toastr.success("Visit rescheduled successfully");
                const dataObj = {
                  totalRecords: this.localPaginationObject.totalRecords,
                  totalPage: this.localPaginationObject.totalPage,
                  pageIndex: this.localPaginationObject.currentPage
                };
                this.$emit("updatetSiteTeamRecords", dataObj);
              }
            },
            err => {
              this.$toastr.error(err.body.message);
            }
          );
        } else {
          const updateObj = {
            address: data.participantAppointmentContact ? data.participantAppointmentContact.address : "",
            city: data.participantAppointmentContact ? data.participantAppointmentContact.city : "",
            state: data.participantAppointmentContact ? data.participantAppointmentContact.state : "",
            country: data.participantAppointmentContact ? data.participantAppointmentContact.country : "",
            zipcode: data.participantAppointmentContact ? data.participantAppointmentContact.zipcode : "",
            countryCode: data.participantAppointmentContact ? data.participantAppointmentContact.countryCode : "",
            phoneNumber: data.participantAppointmentContact ? data.participantAppointmentContact.phoneNumber : "",
            smsCountryIsoName: data.participantAppointmentContact ? data.participantAppointmentContact.smsCountryIsoName : "",
            visitNote: data.visitNote
          };
          this.$api.updateVisitAppointmentFact(this.studyId, this.participantInfo.siteId, this.siteTeamSelectedTaskDetails.responseId, this.siteTeamSelectedTaskDetails.participantId, updateObj).then(
            response => {
              if (response.body) {
                this.$toastr.success("Visit Appointment updated successfully");
              }
            },
            err => {
              this.$toastr.error(err.body.message);
            }
          );
        }
      }
    },
    showVisitDetails(record) {
      this.visitTypeDetails = {
        visitType: record.visitType.toLowerCase(),
        threadId: record.participantId,
        participantId: this.participantInfo.userDefinedParticipantId,
        record: record,
        details: ""
      };
      this.editVisitBtnDisabled = false;
      this.$api.getVisitAppoitmentFact(this.studyId, this.participantInfo.siteId, record.responseId, record.participantId).then(
        response => {
          if (response.body) {
            this.visitTypeDetails.details = response.body.participantAppointmentContact ? response.body.participantAppointmentContact : "";
            if (this.visitTypeDetails.details && this.visitTypeDetails.details.countryCode) {
              const checkCountryCodeplus = this.visitTypeDetails.details.countryCode.toString();
              if (checkCountryCodeplus.includes("+") === false) {
                this.visitTypeDetails.details.countryCode = `+${this.visitTypeDetails.details.countryCode}`;
              }
            }
            this.appointmentDetails = response.body;
            if (this.showScheduleVisitModal) {
              this.$refs.visitTypeDataViewModal.show();
            }
            this.showScheduleVisitModal = true;
            if (record.state.toLowerCase().trim() === "reschedule" || this.appointmentDetails.status.toLowerCase().trim() === "sitecancelled") {
              this.editVisitBtnDisabled = true;
            }
            if (this.appointmentDetails.startTime < new Date().getTime()) {
              this.editVisitBtnDisabled = true;
            }
          }
        },
        err => {
          this.$toastr.error(err.body.message);
        }
      );
    },
    closeScreen() {
      this.$refs.visitTypeDataViewModal.hide();
    },
    editVisit() {
      let getVisitType = this.appointmentDetails.visitType;
      switch (getVisitType) {
        case "Homevisit":
          getVisitType = "Home Visit";
          break;
        case "Telehealth":
          getVisitType = "Video Call";
          break;
        case "In-person":
          getVisitType = "Office Visit";
          break;
        case "Phonecall":
          getVisitType = "Phone Call";
          break;
      }
      const getSelectedVisitTypeIndex = this.mapVisitsData.scheduleVisitType.findIndex(obj => obj.name === getVisitType);
      const self = this;
      const getvisitsDateSlots = JSON.parse(JSON.stringify(this.mapVisitsData.dateTotalValues));
      const uniqueVisitDatesSlots = [];
      getvisitsDateSlots.push({
        dateValue: self.appointmentDetails.startTime,
        index: this.mapVisitsData.dateTotalValues.length - 1,
        selected: false
      });
      for (let m = 0; m < getvisitsDateSlots.length; m++) {
        if (uniqueVisitDatesSlots.length === 0) {
          uniqueVisitDatesSlots.push({
            dateValue: getvisitsDateSlots[m].dateValue,
            index: 0,
            selected: false
          });
        } else {
          const getDuplicateCheckCount = uniqueVisitDatesSlots.findIndex(v => {
            return new Date(v.dateValue).toLocaleDateString() === new Date(getvisitsDateSlots[m].dateValue).toLocaleDateString();
          });
          if (getDuplicateCheckCount === -1) {
            uniqueVisitDatesSlots.push({
              dateValue: getvisitsDateSlots[m].dateValue,
              index: uniqueVisitDatesSlots.length + 1,
              selected: false
            });
          }
        }
      }
      this.mapVisitsData.dateTotalValues = uniqueVisitDatesSlots;
      const getSelectedDateVisitTypeIndex = this.mapVisitsData.dateTotalValues.findIndex(dateObj => {
        return new Date(dateObj.dateValue).toLocaleDateString() === new Date(self.appointmentDetails.startTime).toLocaleDateString();
      });
      const getSavedDateFormatVisitStringValue = new Date(self.appointmentDetails.startTime).toLocaleDateString().split("/");
      const saveTimeObj = {
        appointmentSlotId: this.appointmentDetails.piAvailabilitySlot,
        availabilityId: this.appointmentDetails.piAvailabilityId,
        currentDate: this.appointmentDetails.startTime,
        dateString: getSavedDateFormatVisitStringValue[2] + "-" + getSavedDateFormatVisitStringValue[0] + "-" + getSavedDateFormatVisitStringValue[1],
        dateValue: this.appointmentDetails.startTime,
        extendWindowSlot: this.visitConfiguredDetails.telehealthVisitDTO.extendAvailability,
        selected: null,
        siteId: this.appointmentDetails.siteId,
        slotDate: this.appointmentDetails.startTime,
        slotEndTime: this.appointmentDetails.endTime,
        slotStartTime: this.appointmentDetails.startTime,
        timeZone: this.getLocalOffset()
      };
      this.mapVisitsData.timeTotalValues.push(saveTimeObj);
      this.mapVisitsData.scheduleVisitType[getSelectedVisitTypeIndex].selected = true;
      this.mapVisitsData.dateTotalValues[getSelectedDateVisitTypeIndex].selected = null;
      const selectedDateTimeLists = this.mapVisitsData.timeTotalValues.filter(dateTimeObj => {
        return new Date(dateTimeObj.dateValue).toLocaleDateString() === new Date(self.appointmentDetails.startTime).toLocaleDateString();
      });
      this.mapVisitsData.selectedDateTimeLists = selectedDateTimeLists;
      if (!this.editVisitBtnDisabled) {
        this.showScheduleVisit = true;
        this.$refs.visitTypeDataViewModal.hide();
      }
    },
    async callVisitDetails(record) {
      this.siteTeamSelectedTaskDetails = record;
      if (record.label != "Missed") {
        const getDataList = await this.$api.getPI_ID(this.studyId, this.participantInfo.siteId);
        this.piDetails = getDataList.body.find(data => data.id === this.user.id);
        const getSlotsData = await this.$api.getTelehealthVisitSlotsFact(this.studyId, this.participantInfo.siteId, record.participantId, record.taskId, record.taskInstanceId, this.getLocalOffset(), this.getLocalTimeZone());
        this.processSlotsDateTime(getSlotsData.body, record);
      }
    },
    showVisitAddress(details) {
      let formString = "";
      if (details.address != "") {
        formString = details.address;
      }
      if (details.city != "") {
        formString = formString + ", " + details.city;
      }
      if (details.state != "") {
        formString = formString + ", " + details.state;
      }
      if (details.country != "") {
        formString = formString + ", " + details.country;
      }
      if (details.zipcode != "") {
        formString = formString + ", " + details.zipcode;
      }
      return formString;
    },
    getLocalOffset() {
      const offset = new Date().getTimezoneOffset();
      const o = Math.abs(offset);
      return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
    },
    processSlotsDateTime(slotsList, record) {
      const getDates = Object.keys(slotsList);
      const getTimeValues = [];
      this.mapVisitsData.dateTotalValues = [];
      for (let i = 0; i < getDates.length; i++) {
        const dateObject = {
          selected: false,
          dateValue: parseInt(getDates[i]),
          index: i
        };
        this.mapVisitsData.dateTotalValues.push(dateObject);
        const timeValuesObject = {
          [getDates[i]]: slotsList[getDates[i]]
        };
        getTimeValues.push(timeValuesObject);
      }
      this.mapVisitsData.timeTotalValues = [];
      for (let j = 0; j < getDates.length; j++) {
        this.formatTimeValues(getDates[j], getTimeValues);
      }
      if (record.responseId === null || record.responseId === "") {
        if (this.mapVisitsData.dateTotalValues.length === 0) {
          this.$toastr.error("Slots are not available please configure slots and schedule the visit");
        } else {
          this.showScheduleVisit = true;
        }
      }
    },
    formatTimeValues(dateValue, getTimeValues) {
      const getfilteredTimeValues = getTimeValues.filter(data => {
        return data[dateValue];
      });
      const timesValues = Object.keys(getfilteredTimeValues[0][dateValue]);
      for (let j = 0; j < timesValues.length; j++) {
        const obj = getfilteredTimeValues[0][dateValue][timesValues[j]];
        obj.selected = false;
        obj.dateValue = getfilteredTimeValues[0][dateValue][timesValues[j]].slotStartTime;
        obj.currentDate = parseInt(dateValue);
        this.mapVisitsData.timeTotalValues.push(obj);
      }
    },
    getVisitConfigDetails(studyId, record) {
      if (record.label != "Missed") {
        this.siteDetailsInfo = this.studyResponse.sitesInfo.filter(data => data.id === this.participantInfo.siteId)[0];
        this.$api.getSoftVisitDetail(studyId, record.taskId).then(
          response => {
            const getVisitTypes = response.body.telehealthVisitDTO.visitType;
            const visitSplitData = getVisitTypes.split("|");
            const visitsDataObject = [];
            for (let i = 0; i < visitSplitData.length; i++) {
              if (visitSplitData[i] === "Telehealth") {
                visitsDataObject.push({
                  name: "Video Call",
                  logoUrl: "static/img/telehealth/video-call-icon.svg",
                  selected: false
                });
              } else if (visitSplitData[i] === "In-person") {
                visitsDataObject.push({
                  name: "Office Visit",
                  logoUrl: "static/img/telehealth/office-visit-icon.svg",
                  selected: false
                });
              } else if (visitSplitData[i] === "Homevisit") {
                visitsDataObject.push({
                  name: "Home Visit",
                  logoUrl: "static/img/telehealth/home-visit-icon.svg",
                  selected: false
                });
              } else if (visitSplitData[i] === "Phonecall") {
                visitsDataObject.push({
                  name: "Phone Call",
                  selected: false,
                  logoUrl: "static/img/telehealth/phone-call-icon.svg"
                });
              }
            }
            this.mapVisitsData.scheduleVisitType = visitsDataObject;
            this.visitConfiguredDetails = response.body;
            this.callVisitDetails(record);
          },
          error => {
            this.$toastr.error(error.body ? error.body.message : "Error while fetching telehealth visits");
            nprogress.done();
          }
        );
      }
    },
    getDateFormatString(selectedDate, dateFormat) {
      const record = selectedDate;
      const timeZone = moment.tz.guess();
      const time = new Date();
      const timeZoneOffset = time.getTimezoneOffset();
      const abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
      const getdate = momentTimeZone(record)
        .tz(abbr)
        .format(dateFormat);
      this.selectedDateFormatString = `${getdate}`;
      return this.selectedDateFormatString;
    },
    checkforRescheduleFlag(dataObj) {
      let rescheduleFlag = false;
      if (dataObj.visitType != this.appointmentDetails.visitType) {
        rescheduleFlag = true;
      } else if (dataObj.piAvailabilitySlot != this.appointmentDetails.piAvailabilitySlot) {
        rescheduleFlag = true;
      } else if (dataObj.piAvailabilityId != this.appointmentDetails.piAvailabilityId) {
        rescheduleFlag = true;
      }
      return rescheduleFlag;
    },
    cancelVisitDataEvent(data) {
      this.showScheduleVisit = false;
      this.$api.deleteVisitAppointmentFact(this.studyId, this.participantInfo.siteId, this.siteTeamSelectedTaskDetails.responseId, this.siteTeamSelectedTaskDetails.participantId, data).then(
        response => {
          if (response.body) {
            this.$toastr.success("Visit Appointment cancelled successfully");
          }
        },
        err => {
          this.$toastr.error(err.body.message);
        }
      );
    },
    getLocalTimeZone() {
      return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    clickStopVisitModal() {
      this.showScheduleVisitModal = false;
    },
    formatUserRole(name) {
      return name.replace(/[- ]/g, "").toLowerCase();
    },
    isFormOrPacketRemoved(record) {
      return record && record.label && record.label.toLowerCase() === "removed";
    }
  },
  mounted() {
    this.$root.$on("playBackVideoEnded", () => {
      this.mainActiveArchiveId = null;
      this.activeArchiveId = null;
      this.$root.recordingPage = { pageName: null };
    });
    this.$root.$on("switchVideo", archive => {
      this.activeArchiveId = archive.archiveId;
    });
  }
};
</script>

<style scoped lang="scss" src="@/assets/table-styling.scss"></style>
<style scoped lang="scss" src="@/assets/dot-streaching-loader.scss"></style>
<style scoped lang="scss">
.site-team-table {
  padding: 0px 20px 0px !important;
  margin-bottom: 25px;
  overflow-x: auto;
  .table-title {
    font-size: 15px;
  }
  .text-info {
    color: #1e8fe1 !important;
    cursor: pointer;
    font-weight: 600;
    padding-left: 20px;

    & .removed-form-name {
      white-space: nowrap;
      width: auto;
      display: inline-block;
      color: #b0bac9 !important;
      cursor: default !important;
      text-overflow: ellipsis;
      overflow: hidden;
      position: relative;
      top: 7px;
    }
  }
  .text-info:hover {
    text-decoration: none;
  }
  .due-date-indicator {
    display: inline-block;
    color: #4a4a4a;
    opacity: 0.5;
    border: solid 2px #e4e8eb;
    background-color: #f7f7f7;
    padding: 0px 5px;
    height: 27px;
    width: 100px;
    border-radius: 5px;
  }
  .color-text {
    color: #a8a8a8;
  }
  .clock {
    margin-top: -3px;
  }
  .card {
    .card-body {
      border-right: 1px solid #e4e8eb;
      border-left: 1px solid #e4e8eb;
      border-bottom: 1px solid #e4e8eb;
      .divTable {
        width: 100%;
      }
    }
  }
  .toggle-text {
    background-color: #fff;
    border-right: 1px solid #e4e8eb;
    border-left: 1px solid #e4e8eb;
    border-bottom: 1px solid #e4e8eb;
    border-top: none;
    span {
      background-image: url(/static/img/arrow-down-blue.png) !important;
      height: 20px;
      display: inline-block;
      background-repeat: no-repeat;
      width: 20px;
      background-position-y: 1px;
      background-position-x: 1px;
    }
    .collapsed {
      vertical-align: top;
      transform: rotate(180deg);
      background-position-y: -1px;
      background-position-x: -1px;
    }
  }
  .status {
    font-weight: 400;
    margin: 0px 10px !important;
  }
  .of {
    margin-right: -1px;
    margin-left: 2px;
  }
  .ttlPge {
    margin-left: -7px;
  }
  .loading-div {
    border: 1px solid #e4e8eb;
    border-top: none;
    height: 45px;
    .loading-class {
      padding: 15px 0px 0px;
      width: 2%;
      margin: 0 auto;
    }
  }
  .skipped-task {
    margin-left: 5px;
    img {
      width: auto;
      height: 15px;
    }
  }
}
.popover-camera-content {
  .camera {
    width: 19px;
    height: 17px;
  }
  div {
    display: inline-block;
  }
}
.telehealth-call {
  .clock {
    width: 10px;
    height: 10px;
  }
}
.form-name {
  white-space: nowrap;
  width: auto;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  top: 7px;
}
popover-content {
  position: relative;
  color: #4a4a4a;
  font-family: Roboto-Regular;
  font-size: 14px;
  opacity: 0.7;
  div {
    display: inline-block;
  }
  span {
    display: inline-block;
    width: 12px;
    height: 11px;
    background-repeat: no-repeat;
    position: absolute;
    top: 5px;
    &.clinic {
      background-image: url(/static/img/date-clinic-icon.svg);
    }
  }
}
.quick-view-icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.activityNameLayout {
  position: relative;
  top: 0.1rem;
}
.subHeading {
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
}
.evaluateAddressField {
  color: #4a4a4a;
  font-weight: bold;
}
.evaluateModalPhnoField {
  color: rgba(0, 0, 0, 0.5);
  font-weight: bold;
}
.cancelText {
  color: #666669;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.visitTypeIcon {
  width: 18px;
  height: 20px;
  cursor: pointer;
  margin-bottom: 0.2rem;
  position: relative;
  left: 15rem;
}
.visitTypeIconDisplay {
  width: 18px;
  height: 20px;
  cursor: pointer;
  margin-left: 8px;
}
.visitPreSelectedIcon {
  width: 20px;
  height: 25px;
}
.visitTypeVideoCallIconDisplay {
  width: 25px;
  height: 25px;
  cursor: pointer;
  margin-left: 8px;
}
.dueDateClass {
  position: relative;
  left: 0.4rem;
}
@media only screen and (max-width: 768px) {
  .pl-85 {
    padding-left: 25px !important;
  }
  .site-team-table .text-info {
    padding-left: 1% !important;
  }
}
@media only screen and (max-width: 1024px) {
  .pl-85 {
    padding-left: 25px !important;
  }
  .site-team-table .text-info {
    padding-left: 1% !important;
  }
}
@media only screen and (min-width: 320px) and (max-width: 359px) {
  .form-name {
    width: 170px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1111px) {
  .site-team-table {
    .text-info {
      padding-left: 5%;
    }
    .status {
      margin: 0px 0px !important;
    }
  }
  .divTableHead.width-300.pl-85 {
    padding-left: 6% !important;
  }
  .divTableHead.width-200.pl-50 {
    padding-left: 5% !important;
  }
}

.form-name-reschedule {
  white-space: nowrap;
  width: 269px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
  top: 7px;
}
// .no-task{
//     width: 1325px;
//     min-width: auto !important;
// }
.divTableHead b {
  font-size: 12px;
  color: #9b9b9b;
}
.show_all_div {
  max-width: 1980px;
  width: 193.8%;
}
.hide {
  display: none;
}
.ondemand-activity-icon {
  background-color: #4c8ce4;
  padding: 0px 2px 1px 3px;
  border-radius: 2px;
  img {
    width: 15px;
    height: 15px;
  }
}
</style>
